import { Panel } from '../core/Panel';
import { Sim } from '../../game/simulation';
import { t } from '../strings';

/**
 * Plot Confirm — opens after the player drag-selects a region. Shows the
 * tile count and offers Adopt / Cancel. Adopt → sim.confirmPlot() takes
 * over and the camera dives onto the plot. Cancel clears the selection.
 *
 * Re-renders whenever the selection changes (drag still in progress is
 * allowed — the panel updates live).
 */
export class PlotConfirmPanel extends Panel {
  constructor(sim: Sim) { super(sim); }
  id() { return 'plot-confirm'; }
  title() { return t('plot.confirm.title'); }
  hashInputs() {
    const s = this.sim.state.selecting;
    // The default-name placeholder reads plots.length too; include it so a
    // mid-selection plot removal / addition refreshes the suggested name.
    return JSON.stringify({
      n: s ? s.tiles.length : -1,
      plots: this.sim.state.plots?.length ?? 0,
    });
  }
  body() {
    const s = this.sim.state.selecting;
    if (!s) return '';
    const n = s.tiles.length;
    if (n === 0) {
      return `
        <div class="ui-tip">${t('plot.confirm.tip.empty')}</div>
        <button class="ui-btn ui-btn--block" data-act="cancel">${t('plot.confirm.btn.cancel')}</button>
      `;
    }
    const defaultName = t('plot.confirm.namePlaceholder', { n: (this.sim.state.plots?.length ?? 0) + 1 });
    return `
      <div class="ui-section">
        <div class="ui-section__title">${t('plot.confirm.section')}</div>
        <div class="ui-row"><span>${t('plot.confirm.tiles')}</span><strong>${n}</strong></div>
        <label class="ui-tip" style="display:block; margin-top:8px;">
          ${t('plot.confirm.nameLabel')}
          <input class="ui-input" type="text" data-field="name" placeholder="${defaultName}" maxlength="24" />
        </label>
      </div>
      <div class="ui-tip">${t('plot.confirm.tip.named')}</div>
      <button class="ui-btn ui-btn--primary ui-btn--block" data-act="confirm">${t('plot.confirm.btn.adopt')}</button>
      <button class="ui-btn ui-btn--block" data-act="cancel">${t('plot.confirm.btn.cancel')}</button>
    `;
  }
  onClick(e: Event) {
    const t = e.target as HTMLElement;
    const act = (t.closest('[data-act]') as HTMLElement | null)?.dataset.act;
    if (act === 'confirm') {
      const inp = (this.root as any).querySelector('[data-field="name"]') as HTMLInputElement | null;
      const name = inp?.value?.trim() || undefined;
      if (this.sim.confirmPlot(name)) this.hide();
    } else if (act === 'cancel') {
      this.sim.cancelPlotSelect();
      this.hide();
    }
  }
}
